import { z } from "zod";
// // eslint-disable-next-line alfred/no-barrel-imports
import * as status from "./order-statuses/_barrel";

const orderStatusZodSchema = z.discriminatedUnion("type", [
    status.orderStatusBookableReservationUpdatedZodSchema,
    status.orderStatusBookableTimeChangeZodSchema,
    status.orderStatusBookableTimeUpdatedZodSchema,
    status.orderStatusCancelledZodSchema,
    status.orderStatusConfirmedZodSchema,
    status.orderCreatedStatusZodSchema,
    status.orderStatusFulfilledZodSchema,
    status.orderStatusOutForDeliveryZodSchema,
    status.orderStatusPaymentFailedZodSchema,
    status.orderStatusPaymentFulfilledZodSchema,
    status.orderStatusPaymentPendingZodSchema,
    status.orderStatusPaymentRefundFailedZodSchema,
    status.orderStatusPaymentRefundFulfilledZodSchema,
    status.orderStatusPaymentRefundInitiatedZodSchema,
    status.orderStatusPaymentRefundPendingZodSchema,
    status.orderStatusPendingConfirmationZodSchema,
    status.orderStatusPendingDeliveryZodSchema,
    status.orderStatusPendingPaymentConfirmationZodSchema,
    status.orderStatusReadyForPickUpZodSchema,
    status.orderStatusRejectedZodSchema,
]);

type OrderStatus = z.infer<typeof orderStatusZodSchema>;

export { orderStatusZodSchema };
export type { OrderStatus };
